module.exports = __webpack_public_path__ + "assets/img/ic-24h.61fa60a9.png";